<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Add Incident Report</span>
      <span class="text-light-color body-medium-medium">#{{ config.data.id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (click)="ref.close()"
      (keydown.enter)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    #incidentReportForm="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="flex gap-spacing-xl flex-wrap md:flex-nowrap">
      <div class="w-full form-group">
        <label
          class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
          for="student"
          >Student</label
        >
        <p-select
          (onChange)="setClient($event)"
          [options]="students"
          required
          [(ngModel)]="selectedStudent"
          name="student"
          optionLabel="name"
          placeholder="Select a Student" />
      </div>
      <div class="w-full form-group">
        <label
          class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
          for="client"
          >Client Name</label
        >
        <div [ngClass]="{'form-border-default-border': !clientName, 'bg-white': clientName}" style="min-height: 34px;"
          class="py-spacing-xs w-full px-spacing-md flex flex-column border-1 border-neutral-base-primary-border border-round-md">
          <span class="value label-large-medium text-secondary-color">{{ clientName }}</span>
        </div>
      </div>
    </div>

    <div class="flex gap-spacing-xl flex-wrap md:flex-nowrap">
      <div class="py-spacing-xs w-full px-spacing-md flex flex-column border-1 border-neutral-base-primary-border border-round-md bg-white">
        <span class="title text-sm text-text-caption-color font-medium">Date</span>
        <span class="value label-large-medium text-secondary-color">{{ dateOfService.format("ll") }}</span>
      </div>
      <div class="py-spacing-xs w-full px-spacing-md flex flex-column border-1 border-neutral-base-primary-border border-round-md bg-white">
        <span class="title text-sm text-text-caption-color font-medium">Number of Incident</span>
        <span class="value label-large-medium text-secondary-color">{{incidentCount$ | async}}</span>
      </div>
    </div>

    <div class="form-group w-full">
      <label
        class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
        for="incidentDescription"
        >Incident Description <span class="feedback-danger-fg-color">*</span></label
      >
      <textarea
        rows="5"
        cols="30"
        #incidentDescription
        ngModel
        required
        name="incidentDescription"
        pTextarea
        [autoResize]="true"
        value="''"
        placeholder="Enter description here">
      </textarea>
    </div>
    <div class="form-group w-full">
      <label
        class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
        for="actionsAndRecommendations"
        >Actions Taken and Recommendations</label
      >
      <textarea
        rows="5"
        cols="30"
        #actionsAndRecommendations
        ngModel
        name="actionsAndRecommendations"
        pTextarea
        [autoResize]="true"
        value="''"
        placeholder="Enter actions and recommendations here">
      </textarea>
    </div>
    <div class="form-group w-full">
      <label
        class="input-label mb-spacing-default flex gap-spacing-default align-items-center"
        for="notes"
        >Notes</label
      >
      <textarea
        rows="5"
        cols="30"
        #notes
        ngModel
        name="notes"
        pTextarea
        [autoResize]="true"
        value="''"
        placeholder="Enter a note here">
      </textarea>
    </div>
  </form>
</div>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    [disabled]="!incidentReportForm.valid || loading"
    label="Save"
    (btnClick)="confirmAction()"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
